/**
 * WPS Dental Theme - Main JavaScript
 *
 * @package WPS_Dental_Theme
 */

import { Navigation } from './components/Navigation';
import { ScrollAnimations } from './animations/ScrollAnimations';

/**
 * Initialize theme
 */
class WPSDentalTheme {
  constructor() {
    this.init();
  }

  /**
   * Initialize all components
   */
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.onReady());
    } else {
      this.onReady();
    }
  }

  /**
   * On DOM ready
   */
  onReady() {
    // Initialize components
    this.initNavigation();
    this.initAnimations();
    this.initAOS();
    this.initStickyHeader();
    this.initFullScreenMenu();

  }

  /**
   * Initialize AOS (Animate On Scroll)
   */
  initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 800,
        easing: 'ease-in-out-sine',
        once: true,
        offset: 100,
        delay: 0,
      });
    }
  }

  /**
   * Initialize sticky header
   */
  initStickyHeader() {
      jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 180) {
          jQuery(".header-sticky__wrapper").addClass("sticky");
        } else {
          jQuery(".header-sticky__wrapper").removeClass("sticky");
        }
      });
  }

  /**
   * Initialize full screen menu
   */
  initFullScreenMenu() {
    const menuToggleBtn = document.querySelector("#mobile-menu-trigger");
    const menuToggleBtn2 = document.querySelector("#mobile-menu-trigger1");
    const menuCollapseLinks = document.querySelectorAll(".collape-menu");
    const menuCloseBtn = document.querySelector(".close-btn");
    const fullScreenMenu = document.querySelector(".wps-full-screen-menu__wrapper");

    // Exit if menu doesn't exist
    if (!fullScreenMenu) return;

    const parentMenu = fullScreenMenu.querySelectorAll(
      ".menu-item-has-children > a"
    );

    const handleCollapse = function (curr) {
      parentMenu.forEach((menu) => {
        const submenu = menu.nextElementSibling;
        const parent = menu.parentElement;

        if (curr === menu && parent.classList.contains("active")) return;

        menu.classList.remove("rotate");
        menu.classList.remove("active");
        if (submenu) {
          submenu.style.maxHeight = null;
        }
      });
    };

    const handleOpen = function () {
      fullScreenMenu.classList.add("active");
      document.body.classList.add("add-bg-color");
      document.body.style.overflow = "hidden";
      
      // Check if GSAP timeline exists
      if (typeof fullScreenMenuOpenTl !== 'undefined') {
        fullScreenMenuOpenTl.restart();
      }
    };

    const handleClose = function () {
      fullScreenMenu.classList.remove("active");
      document.body.classList.remove("add-bg-color");
      handleCollapse();
      document.body.style.overflow = "visible";

      // Check if GSAP timeline exists
      if (typeof fullScreenMenuCloseTl !== 'undefined') {
        fullScreenMenuCloseTl.restart();
      }
    };

    // Event listeners
    if (menuToggleBtn) {
      menuToggleBtn.addEventListener("click", function () {
        handleOpen();
      });
    }

    if (menuToggleBtn2) {
      menuToggleBtn2.addEventListener("click", function () {
        handleOpen();
      });
    }

    if (menuCloseBtn) {
      menuCloseBtn.addEventListener("click", function () {
        handleClose();
      });
    }

    menuCollapseLinks.forEach((link) => {
      link.addEventListener("click", function () {
        handleClose();
      });
    });

    parentMenu.forEach((menu) => {
      menu.addEventListener("click", function (e) {
        e.preventDefault();
        const currentLink = e.target;
        const submenu = currentLink.nextElementSibling;

        if (!currentLink.classList.contains("active")) {
          currentLink.classList.add("rotate");
          currentLink.classList.add("active");
          if (submenu) {
            submenu.style.maxHeight = submenu.scrollHeight + 10000000 + "px";
          }
        } else {
          currentLink.classList.remove("rotate");
          currentLink.classList.remove("active");
          if (submenu) {
            submenu.style.maxHeight = null;
          }
        }
      });
    });

    fullScreenMenu.addEventListener("click", function (e) {
      if (e.target === fullScreenMenu) {
        handleClose();
      }
    });

    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        handleClose();
      }
    });
  }

  /**
   * Initialize navigation
   */
  initNavigation() {
    const nav = document.querySelector('.main-navigation');
    if (nav) {
      new Navigation(nav);
    }
  }

  /**
   * Initialize GSAP animations
   */
  initAnimations() {
    if (typeof gsap !== 'undefined') {
      new ScrollAnimations();
    }
  }
}

// Initialize theme
new WPSDentalTheme();


//
